import { changeDateFormatToMonthDayYear, splitTimeString } from "../../../../../utils";
import MissingStatusUser from "./MissingStatusUser";

export const columns =(isMobile)=>{
return [
    {
      field: "username",
      headerName: "User Name",
      renderCell: (params) => {
        return (
          <div className="report-user-name">
            <MissingStatusUser params={params} />
          </div>
        );
      },
      minWidth: isMobile && 180,
      // headerClassName: 'paddingLeft',
      flex: 1.5,
      // editable: true,
      // sortable: false,
    },
    {
      field: "date",
      headerName: "Date",
      renderCell: (params) => {
        return (
          <div className="report-date">
            {changeDateFormatToMonthDayYear(
              splitTimeString(params.row.date)[0].replaceAll("-", "/")
            )}
          </div>
        );
      },
      // width: 200,
      minWidth: isMobile && 100,
      flex: 1.2,
      // editable: true,
      sortable: false,
    },
    {
      field: "total_hours_spent",
      headerName: "Hours Logged",
      renderCell: (params) => {
        return (
          <div className="report-date">
            {`${params.row.total_hours_spent}/8`}
          </div>
        );
        // return `${params.row.total_hours_spent}/8`;
      },
      // width: 200,
      minWidth: isMobile && 100,
      flex: 1.1,
      // editable: true,
      sortable: false,
    },
    {
      field: "notes",
      headerName: "Notes",
      minWidth: isMobile && 100,
      flex: 2,
      // editable: true,
      sortable: false,
    },
    {
      field: "delay",
      headerName: "Delay",
      renderCell: (params) => {
        return (
          <div className="report-date">
            {params.row.delay ? params.row.delay : "NA"}
          </div>
        );
        // return params.row.delay ? params.row.delay : 'NA';
      },
      // width: 200,
      minWidth: isMobile && 80,
      flex: 0.8,
      // editable: true,
      sortable: false,
    },
  ]
}